import {tns} from 'tiny-slider/src/tiny-slider'; 
import Parallax from '../../../utils/Parallax';

class AboutUs{
    constructor(){
        this.main = document.getElementById('about_us');

        this._mapSection = document.getElementById('about_us_map');

        // Init Parallax
        setTimeout(()=>{
            Parallax.init();
        }, 500);

        this._about_us_people_slider = tns({
            container: '#about_us_people_slider',
            nav: false,
            controls: false,
            center: false,
            mouseDrag: true,
            speed: 500,
            loop: false,
            autoplay: false,
            gutter: 0,
            autoplayButtonOutput: false,
            autoplayTimeout: 2000,
            slideBy: 1,
            preventScrollOnTouch: 'auto',
            swipeAngle: 45,
            items: 3.6,
            responsive: {
              520: {
                  items: 4.6,
              },
              767: {
                  items: 5.6,
              },
              1100: {
                  gutter: 0,
                  items: 7,
                  edgePadding: 0,
              },
            }
          });
    }
}

export default AboutUs;